module.exports = __webpack_public_path__ + "static/img/drawer1.bf470a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/drawer/drawer1.png
// module id = mxJn
// module chunks = 12